import { BulkUpload } from './bulkUpload';
import { ReferenceUpload } from './referenceUpload';

export class BulkUploadReferences extends BulkUpload {
  References: ReferenceUpload[];
}
